import useIsMobile from 'hooks/use-is-mobile';
import { useEffect } from 'react';
import trackAppleMapsExperience from 'segment/pages/apple-maps-experience';
import { useSelector } from 'react-redux';
export const useAppleMapsPartnerTracking = () => {
    const isMobile = useIsMobile();
    const partner = useSelector((state) => state.searchRequest.partner);
    const searchType = useSelector((state) => state.search.data.searchType);
    const appleMapsPartner = partner === 'apple' || partner === 'appleTest';
    useEffect(() => {
        if (appleMapsPartner && isMobile) {
            trackAppleMapsExperience({ searchType });
        }
    }, [appleMapsPartner, isMobile, searchType]);
};
